import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { WhatsAppCtaBanner } from "../components/WhatsAppCtaBanner";
import { PriceTablesFull } from "../components/PriceTablesFull";
import { SectionEyebrow } from "../components/SectionEyebrow";
import { useSeo } from "../hooks/useSeo";

const PricesPage = () => {
  const { t } = useTranslation();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  useSeo({
    title: t("seo.prices_title"),
    description: t("seo.prices_description"),
    canonicalPath: "/preise", // DE canonical; useSeo translates per language via slug swap
  });

  return (
    <div className="bg-[#F6F5F2]">
      <section className="pt-36 lg:pt-44 pb-12 bg-[#F6F5F2]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <SectionEyebrow num="01">{t("prices.eyebrow")}</SectionEyebrow>
          <h1 className="font-serif text-5xl lg:text-7xl font-light tracking-tight leading-[0.95] text-[#3E5239]">
            {t("prices.title_l1")}
            <br />
            <span className="italic text-[#A7CA99]">{t("prices.title_l2")}</span>
          </h1>
          <p className="mt-8 max-w-2xl text-base lg:text-lg font-light text-[#6B7A66] leading-relaxed">{t("prices.intro")}</p>
        </div>
      </section>

      <PriceTablesFull />

      <WhatsAppCtaBanner source="prices_page_bottom" />
    </div>
  );
};

export default PricesPage;
